module.exports = __webpack_public_path__ + "img/Teaser-Video_1.a1e5963d.jpg";